import { connect } from 'react-redux';

import { handleAjaxError, showSuccessFlag } from '@helpcenter/flags';
import { resetLogin } from 'state/actions/login';
import ForgotPasswordConfirmation from './forgot-password-confirmation';

export default connect(undefined, {
    resetLoginAction: resetLogin,
    onResendLinkError: handleAjaxError,
    onResendSuccess: showSuccessFlag,
})(ForgotPasswordConfirmation);
